import "./Sudinoi.css";
import { Helmet } from "react-helmet";

const Sudinoi = () => {
    return (
        <>
            <Helmet>
                <title>Sporting - Su di noi</title>
                <meta
                    name="description"
                    content="Scopri chi ha realizzato la web app Sporting Saluzzo."
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <div id="su-di-noi">
                <p>
                    Questa Web App è stata realizzata dall'
                    <b>IIS Denina Pellico Rivoira</b>, sezione <b>ITIS Rivoira</b> come
                    progetto scolastico.
                </p>
                <a href="https://www.denina.it">Vieni a trovarci</a>
                <p id="by">Creato da Rera Alessio e Castaldo Antonio</p>
                <p id="warning">
                    I creatori del sito non si assumono alcuna responsabilità legale di
                    eventuali perdite di dati.
                </p>
            </div>
        </>
    );
};

export default Sudinoi;